import Flex from '@Components/Bases/Flex';
import FormCheckbox from '@Components/Form/FormCheckBox';
import { Divider, Typography } from '@mui/material';
import { formatToShortThaiDateTime } from '@Utils/datetime';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useFormContext, useWatch } from 'react-hook-form';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { BusinessValueChainFormValues } from '../ImpactsOnStakeholdersFormProvider/types';
import {
  checkBizAssetsValidEn,
  checkBizAssetsValidTh,
  checkBizIntroductionEnValid,
  checkBizIntroductionThValid,
  checkBizRemarkEnValid,
  checkBizRemarkThValid,
  checkBizValueCompletionEn,
  checkBizValueCompletionTh,
} from './utils';
import { resetCompletedSection } from '@Utils/updateCompletedSection';

const BusinessValueChainsFormComplete = () => {
  const { isPublished } = useProgressBar();
  const completedSection = useWatch({
    name: 'businessValueChain.completedSection',
  }) as CompleteSectionFormValues | undefined;
  const {
    isCompletedTh,
    isCompletedEn,
    dateTh,
    dateEn,
    roleStampTh,
    roleStampEn,
  } = completedSection || {};
  const { setValue } = useFormContext();

  const formattedCompletedSectionDateTh = dateTh
    ? formatToShortThaiDateTime(dateTh)
    : '';
  const formattedCompletedSectionDateEn = dateEn
    ? formatToShortThaiDateTime(dateEn)
    : '';

  const businessValueChain = useWatch({
    name: 'businessValueChain',
  }) as BusinessValueChainFormValues;

  const isCompleteTh =
    checkBizValueCompletionTh(businessValueChain) &&
    checkBizAssetsValidTh(businessValueChain) &&
    checkBizRemarkThValid(businessValueChain) &&
    checkBizIntroductionThValid(businessValueChain);
  const isCompleteEn =
    checkBizValueCompletionEn(businessValueChain) &&
    checkBizRemarkEnValid(businessValueChain) &&
    checkBizIntroductionEnValid(businessValueChain) &&
    checkBizAssetsValidEn(businessValueChain);

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    language: 'Th' | 'En'
  ) => {
    const updatedSection = { ...completedSection };

    if (language === 'Th') {
      updatedSection.isCompletedTh = e.target.checked;
    } else {
      updatedSection.isCompletedEn = e.target.checked;
    }

    resetCompletedSection(updatedSection, setValue, 'businessValueChain');
  };

  return (
    <>
      <Divider />
      <Flex gap={4} justifyContent={'center'} bgcolor={'grey.50'} py={1}>
        <Flex alignItems={'center'}>
          <Typography fontWeight="bold" textAlign={'right'}>
            ยืนยันการตรวจสอบข้อมูลครบถ้วน
          </Typography>
        </Flex>
        <Flex>
          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              name="businessValueChain.completedSection.isCompletedTh"
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาไทย)"
              inputProps={{ disabled: isPublished || !isCompleteTh }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleCheckboxChange(e, 'Th')
              }
            />
            {isCompletedTh && dateTh && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampTh} {formattedCompletedSectionDateTh}
              </Typography>
            )}
          </Flex>

          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              sx={{ ml: 2 }}
              name="businessValueChain.completedSection.isCompletedEn"
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาอังกฤษ)"
              inputProps={{ disabled: isPublished || !isCompleteEn }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleCheckboxChange(e, 'En')
              }
            />
            {isCompletedEn && dateEn && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampEn} {formattedCompletedSectionDateEn}
              </Typography>
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
export default BusinessValueChainsFormComplete;
